<!--
/**
  * 搜索栏组件
  * @date 2023-06-15
  使用说明：
    hasHeadTop(*true|false) 是否显示搜索栏顶部div
    hasLeftTitle(*true|false) 是否显示搜索栏顶部标题栏
    hasCloseSearch(*true|false) 是否显示展开收起操作栏
    hasSearchResetBtn(*true|false) 是否显示收起展开操作旁边的重置按钮
    hasSearchWords(*true|false) 是否显示模糊查询输入框
    searchPlaceholder 模糊查询提示内容
    openSearchForm(*false|true) 默认操作栏收起/展开
    showDivider(*true|false) 是否显示下划线样式
    hasButton(*true|false) 展开操作栏是否显示操作按钮
  */
-->
<template>
  <div class="search-head model">
    <div class="head-top" v-if="hasHeadTop">
      <div class="left-title" v-if="hasLeftTitle">
        <img v-show="title" alt="" />
        <span v-show="title">{{ title }}</span>
      </div>
      <div v-show="hasSearchWords" class="el-col el-col-6 search-input" :style="{right: hasSearchResetBtn && hasCloseSearch?'2rem':hasSearchResetBtn && !hasCloseSearch?'1rem':'0.2rem'}">
            <el-input
              :placeholder="searchPlaceholder"
              v-model="searchWords"
              >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn()"></i>
        </el-input>
      </div>
      <div class="right-close" >

        <span  v-show="hasCloseSearch" class="close" @click="closeSearch">{{
            curOpenSearchForm ? "收起筛选" : "展开筛选"
        }}</span>
        <i  v-show="hasCloseSearch" @click="closeSearch"
          :class="curOpenSearchForm ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        ></i>
        &nbsp;
        <span class="close" v-show="hasSearchResetBtn" @click="resetSearch">重置</span>
        <i v-show="hasSearchResetBtn" @click="resetSearch" class="el-icon-refresh"></i>
      </div>
    </div>
    <div :style="{ height: curOpenSearchForm ? '.12rem' : '.05rem' }">
      <div v-show="showDivider" class="divider"></div>
    </div>
    <el-form
      v-show="curOpenSearchForm"
      ref="formData"
      :model="formData"
      :label-width="labelWidth"
    >
      <el-form-item
        v-for="(item, index) in formList"
        v-if="
              typeof item.show === 'function'
              ? item.show(item.showIsValid, formData)
              : item.show == false?false:true
          "
        :key="index"
        :label="item.label"
        :style="item.style"
      >
        <!--slot-->
        <template v-if="item.type === 'slot'">
          <slot :name="'form-' + item.value" :value="item" />
        </template>
        <!-- 普通输入框 -->
        <el-input
          v-if="item.type === 'input'"
          :placeholder="item.placeholder?item.placeholder:`请输入${item.label}`"
          v-model="formData[item.value]"
          :type="item.type"
          :disabled="item.disabled"
          :clearable="item.clearable==false?false:true"
        />
        <!-- @change="handleEvent(item.event)" -->
        <!-- 选择框 -->
        <el-select
          v-if="item.type === 'select'"
          v-model="formData[item.value]"
          :multiple="item.multiple"
          :disabled="item.disabled"
          :clearable="item.clearable==false?false:true"
          :filterable="item.filterable"
          :placeholder="item.placeholder?item.placeholder:`请选择${item.label}`"
          @change="
            handleEvent(
              item.event,
              formData[item.value],
              item.label,
              item.multiple
            )
          "
          >
          <el-option
            v-for="(childItem, childIndex) in listTypeInfo[item.list]"
            :key="childIndex"
            :label="childItem.label"
            :value="childItem.value"
          />
        </el-select>
        <!-- <slot name="treeSelect"></slot> -->

         <!-- 树形选择框 -->
         <EXSelectTree
              v-if="item.type === 'tree'"
              :ref="`exSTree-${item.value}`"
              :formData="formData"
              :value="item.value"
              :data="item.treeData"
              :defaultProps="{ children: 'children',label: item.defaultProps.dataName}"
              :multiple="item.multiple"
              :placeholder="item.placeholder?item.placeholder:`请选择${item.label}`"
              :clearable="item.clearable"
              :nodeKey="item.defaultProps.dataCode"
              :checkStrictly="item.checkStrictly"
              :expandOnClickNode="item.expandOnClickNode"
              :isShowFilter="item.isShowFilter"
              :defaultExpandAll="item.defaultExpandAll"
              :isOnlyLeaf="item.isOnlyLeaf"
              @change="
              (value) => handleEvent( item.event,value,item.label,item.multiple)"
            />
          <el-date-picker
              v-if="item.type === 'datetimerange'"
              v-model="formData[item.value]"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="item.TimePickerOptions"
              :clearable="item.clearable==false?false:true"
              :disabled="item.disabled"
              :value-format="item.valueFormat"
              :format="item.format"
              @change="

                  handleEvent(
                    item.event,
                    formData[item.value],
                    item.label,
                    item.multiple
                  )
                "
              style="width:100%"
              >
            </el-date-picker>
           <!--多选框-->
           <el-checkbox-group
              v-if="item.type === 'checkbutton'"
              v-model="formData[`${item.value}Group`]"
              :disabled="item.disabled"
              @change="
                    handleCheckbuttonClick(
                      item.event,
                      formData[`${item.value}Group`],
                      item.value
                    )
                  "
              >
              <el-checkbox-button v-for="childItem in listTypeInfo[item.list]"
                           :label="childItem.value" :key="childItem.value">{{childItem.label}}</el-checkbox-button>
          </el-checkbox-group>
              <!-- 单选选择 -->
              <el-radio-group
                  v-if="item.type === 'radio'"
                  :placeholder="item.placeholder?item.placeholder:`请选择${item.label}`"
                  v-model="formData[item.value]"
                  :disabled="item.disabled"
                  @change="
                    handleEvent(
                      item.event,
                      formData[item.value],
                      listTypeInfo[item.list],
                      item.multiple
                    )
                  "
                  style="width:100%"
              >
                  <el-radio
                  v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                  :key="childIndex"
                  :label="childItem.value"
                  style="line-height:0.42rem"
                  >
                  {{   childItem.label }}</el-radio
                  >
              </el-radio-group>
          <!--统计周期-->
          <EXStatDateSearch
                 v-if="item.type === 'checkstatdate'"
                     :ref="`exStatDate-${item.value}`"
                    :formData="formData"
                    :value="item.value"
                    :defaultProps="item.defaultProps"
                    :statType="item.statType"
                    :showAllStatType="item.showAllStatType"
                    :hasDefaultValue="item.hasDefaultValue"
                    :defaultStatValue="item.defaultStatValue"
                    :showCheckBox="item.showCheckBox"
                    @handleStatDateChange="
                     (value,initflag) => handleStatDateChange( item.event,value,initflag)"
            >
            </EXStatDateSearch>
      </el-form-item>
      <el-form-item class="last-form">
        <div v-if="hasButton" style="display: flex">
          <el-button  v-reClick
            v-for="(item, index) in operationHandleBtn"
            v-if="item.show==false? false : true"
            :key="index"
            :plain="item.plain==false?false:true"
            :type="item.type || 'primary'"
            :icon="item.icon || ''"
            :size="item.size || 'medium'"
            @click="queryFn(item.text,item.event)"
            >{{ item.text }}</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <!-- </div> -->
  </div>
</template>

<script>
import mixin from '@/mixins/mixin'
import EXSelectTree from "@/components/EXForm/EXSelectTree";
export default {
  name: 'EXSearchHead',
  components: {
        EXSelectTree
    },
  mixins: [mixin],
  data() {
    return {
      searchWords: "",
      curOpenSearchForm: this.openSearchForm
    };
  },
  props: {
    labelName: {
      type: String,
      default: "label",
    },
    title: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: String,
      default: "1.3rem",
    },
    formData: {
      type: Object,
      default: {},
    },
    formList: {
      type: Array,
      default: [],
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
    operationHandleBtn: {
      type: Array,
      default: function () {
        return [
          {
            text: "查询",
            type: "primary",
            size: "medium",
            plain: false,
            icon: "fa fa-search",
            show:false
          },
          {
            text: "重置",
            type: "primary",
            size: "medium",
            icon: "fa fa-repeat",
            show: false
          },
        ];
      },
    },
    // 查询
    queryTableFn: {
      type: Function,
    },
    // 重置
    resetTableFn: {
      type: Function,
    },
    listTypeInfo: {
      type: Object,
    },
    //配置是否显示模糊查询输入框
    hasSearchWords: {
      type: Boolean,
      default: true,
    },
    //模糊查询提示文字
    searchPlaceholder:{
      type: String
    },
    //配置是否具有顶部div
    hasHeadTop: {
      type: Boolean,
      default: true,
    },
     //配置是否具有表头标题
     hasLeftTitle: {
      type: Boolean,
      default: true,
    },
    //配置是否具有展开收起
    hasCloseSearch: {
      type: Boolean,
      default: true,
    },
    //配置是否显示下划线样式
    showDivider: {
      type: Boolean,
      default: true,
    },
    //配置关键字输入框默认展开或收起
    openSearchForm: {
      type: Boolean,
      default: false,
    },
    // 是否显示收起展开操作旁边的重置按钮
    hasSearchResetBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    init() {
      // setCurrentKey
    },
    closeSearch() {
      this.curOpenSearchForm = !this.curOpenSearchForm;
    },
    // 查询或重置，调用接口
    queryFn(text,event) {
      if (text == "查询") {
        this.$emit("queryTableFn");
      } else if (text == "重置") {
        this.$emit("resetTableFn");
      } else{
        if(event && typeof event === "function"){
          event()
        }
      }
    },
    // 绑定的相关事件
    handleEvent(event, value, label, multiple) {
      event && typeof event === "function"
        ? event(value, label)
        : this.$emit("fatherEvent", event, value, label, multiple);

        this.$emit("queryTableFn");
    },
    //多选回调事件
    handleCheckbuttonClick(event, value, name){
        //将数组group值转换成字符串
        var str = value.join()
        this.$set(this.formData, name, str); //回填表单值
        this.$forceUpdate();
        if(event && typeof event === "function"){
          event(str)
        }
        this.$emit("queryTableFn");
      },
    //关键字模糊查询
    searchFn() {
      this.$emit("queryTableFn");
    },
    resetSearch() {
      this.$emit("resetTableFn");
    },
    resetEXSTree(field,text){
      this.$refs[`exSTree-${field}`][0].selectedData = text
    },
    handleStatDateChange(event, value, initflag){
      if(event && typeof event === "function"){
          event(value,initflag)
        }
      this.$emit("queryTableFn");
    },
    //封装重置统计日期组件的勾选方法
    resetEXStatDate(field){
      this.$refs[`exStatDate-${field}`][0].resetCurType()
    },
    //设置下拉框选项显示/隐藏
    handleSelectOptions(item){
      const list =  this.listTypeInfo[item.list]
      if(item.showOptions && item.showOptions.length > 0){
        let data = []
        for(var i = 0; i < list.length; i++){
          for(var j = 0; j < item.showOptions.length; j++){
              if(list[i].value == item.showOptions[j]){
                    data.push(list[i])
                    break;
              }
          }
        }
        this.$set(this.listTypeInfo, item.list, data)
        this.$forceUpdate()
      }
      if(item.hideOptions && item.hideOptions.length > 0){
        let data = []
        data = data.concat(list)  //浅拷贝，避免修改字典数组
        for(var i = 0; i < list.length; i++){
          for(var j = 0; j < item.hideOptions.length; j++){
              if(list[i].value == item.hideOptions[j]){
                    data.splice(i, 1);
                    break;
              }
          }
        }
        this.$set(this.listTypeInfo, item.list, data)
        this.$forceUpdate()
      }
    },
    initListTypeInfo(){
        this.formList.map((item) => {
              if(item.dicCode && item.dicCode.trim().length > 0){
                this.mixFeignDictDataList(item.dicCode).then((list)=>{
                    // this.listTypeInfo[item.list] = list
                    this.$set(this.listTypeInfo, item.list,list)
                    this.$forceUpdate()
                    if(item.type == 'select' || item.type == 'checkbutton'){  //字典下拉框显示项筛选
                      this.handleSelectOptions(item)
                    }
                })
              }else{
                if(item.type == 'select' || item.type == 'checkbutton'){  //普通下拉框显示项筛选
                  this.handleSelectOptions(item)
                }
              }
              if(item.type == 'checkbutton'){  //多选框要把数值转换成数组
                var value = this.formData[item.value]
                let ids = []
                if (value) {
                   ids = value.split(',')
                }
                this.$set(this.formData, `${item.value}Group`, ids);
                this.$forceUpdate()
              }
        })
    },
  },
  created(){
    this.initListTypeInfo()
  },
  mounted(){
    if(!this.hasCloseSearch){
        this.curOpenSearchForm = true
    }
  },
  watch:{
	  openSearchForm(val, valOld){  // 这里也可以在 data 定义变量 并将 father 赋值给他， 在这里监控这个变量
	    // 这里做如果 father 变量变化了，子组件需要处理的逻辑
      this.curOpenSearchForm = val
	  },
    formData (val) {
        this.initListTypeInfo()
    },
    formList(val) {
        this.initListTypeInfo()
    },
    listTypeInfo(val){
        this.initListTypeInfo()
    }
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
/deep/ .el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form-item__content {
  // form中的输入框，下拉框等宽度设为100%
  .el-select {
    width: 100%;
  }
}

.search-head {
  // margin-bottom: 0.1rem;
  padding: 0 0.2rem 0.12rem 0.2rem;
  position: relative;
  .head-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left-title {
      height: 0.54rem;
      display: flex;
      align-items: center;
      img {
        display: inline-block;
        width: 0.18rem;
        height: 0.18rem;
        margin-right: 7px;
        @include head_left_img('common.png');
      }
      span {
        // font-size: 0.18rem;
        // font-family: Microsoft YaHei;
        font-weight: bold;
        @include font_color($font-colorD);
        font-size: 0.16rem;
        font-weight: 700;
      }
    }
    .search-input{
      position: absolute;
      right: 2rem;
      .el-icon-search{
        cursor: pointer;
      }
    }
    .right-close {
      &:hover {
        cursor: pointer;
      }
    }
  }

  .divider {
    height: 0.01rem;
    background: #d9d9d9;
  }
}
/deep/ .el-form-item {
  width: 25%;
  margin-bottom: 0;
}
.last-form {
  width: 0.86rem;  //按钮设置自己的宽度
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.052rem;
}
// /deep/ .el-button:nth-child(1) {
//   margin-right: 0.1rem;
// }
/deep/ .el-button {
  height: 0.36rem;
  min-width: 0.86rem;
  display: flex;
  align-items: center;
  span {
    margin-left: 0.05rem;
  }
}
/deep/ .el-date-editor .el-range-separator{
  width: 8%;
}

//操作按钮加手指样式
/deep/ .el-input__inner{
  cursor: pointer;
}
.el-input-group__append{
  cursor: pointer;
}
/deep/ .el-range-input{
  cursor: pointer;
}

//修改表单行间距
/deep/ .el-form-item__label {
      line-height: 0.52rem;
}
/deep/ .el-form-item__content {
    line-height: 0.52rem;
 }
</style>



// WEBPACK FOOTER //
// src/components/EXSearchHead/index.vue